import { render } from "./IOPMecicalDemographicForm.vue?vue&type=template&id=d4a69d46&scoped=true"
import script from "./IOPMecicalDemographicForm.vue?vue&type=script&lang=js"
export * from "./IOPMecicalDemographicForm.vue?vue&type=script&lang=js"

import "./IOPMecicalDemographicForm.vue?vue&type=style&index=0&id=d4a69d46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4a69d46"]])

export default __exports__